export const reducer: WidgetReducerType<ChartState, ChartMessage> = (
    state = { group: [], batch: [], endHistory: false },
    message
) => {
    // test for initialState calls
    if (!message) {
        return state
    }

    if (message.baseline && message.type !== 'event') {
        return state
    }

    switch (message.type) {
        case 'start':
            return { batch: [], group: message.events.group, endHistory: false }

        case 'event':
            return {
                ...state,
                batch: message.events
            }
        case 'endHistory':
            return {
                ...state,
                endHistory: true
            }

        default:
            return state
    }
}
